import "react-perfect-scrollbar/dist/css/styles.css";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useApi } from "../../hooks/api";
import { useGlobal } from "../../hooks/global";
import { AppConstants } from "../../constants";
import { BsCreditCardFill, BsFillHouseFill } from 'react-icons/bs';
import { RiCoupon2Fill, RiDashboardFill, RiUserStarLine } from "react-icons/ri";
import { BsFilePersonFill } from "react-icons/bs";
import { IoSettingsOutline } from "react-icons/io5";
import { IPermissionsTypes } from "../../utils/permissions";
import { FaBook, FaHistory, FaRegBuilding, FaUserTag, FaUserTie } from "react-icons/fa";
import { MdHotel, MdMail, MdOutlineDocumentScanner } from "react-icons/md";
import { MdAppSettingsAlt, MdNotificationsActive } from "react-icons/md";
import { Container, Item, MenuList, Link, IconLink, LinkName, ActiveIndicator, SubMenuList, ItemSubMenu, IconSubMenu, IconArrow, ContainerSubSubMenuItems } from "./style";
import { secondary } from "../../theme";
import { Magikey } from "../SvgComponents/Icons/Magikey";
import { useLocation } from "react-router-dom";
import { TbReportMoney } from "react-icons/tb";
import { useWallet } from "../../hooks/wallet";
import { AiFillApi } from "react-icons/ai";

interface menuItemsProps {
  name: string;
  to: string;
  icon: string;
  iconComponent?: React.ReactElement | any;
  package: string;
  subMenus: menuItemsProps[];
  permissions?: IPermissionsTypes[];
  active?: boolean;
}

export const Sidebar: React.FC = () => {
  const [isHoveredMagikeyIcon, setIsHoveredMagikeyIcon] = useState(false);
  const location = useLocation();

  const {
    menuOpen,
    subMenuOpen,
    setSubMenuOpen,
    theme,
    menuItemSelected,
    setMenuItemSelected,
    setSubMenuItemSelected,
    subMenuItemSelected,
    isMobile,
    business
  } = useGlobal();

  const { user } = useApi();
  const { subscription } = useWallet();
  const { isActiveActions } = useGlobal();

  const activeMenus = useMemo(() => isActiveActions(subscription?.situation), [isActiveActions, subscription?.situation]);

  const isHaveMagikeyPermission = subscription?.plans?.permissions.includes("ELECTRONIC_LOCKS_INTEGRATION") || business?.subscriptions?.plans?.permissions.includes("ELECTRONIC_LOCKS_INTEGRATION") || false;
  const isHaveDashboardPermission = subscription?.plans?.permissions.includes("DASHBOARD") || business?.subscriptions?.plans?.permissions.includes("DASHBOARD") || false;
  const isHaveMsgTemplatesPermission = subscription?.plans?.permissions.includes("PREDEFINED_MESSAGE_TEMPLATES") || business?.subscriptions?.plans?.permissions.includes("PREDEFINED_MESSAGE_TEMPLATES") || false;
  const isHaveAppModulePermission = subscription?.plans?.permissions.includes("APP_MODULE") || business?.subscriptions?.plans?.permissions.includes("APP_MODULE") || false;
  const isHaveMsgRulesPermission = subscription?.plans?.permissions.includes("MESSAGE_SENDING_RULES") || business?.subscriptions?.plans?.permissions.includes("MESSAGE_SENDING_RULES") || false;
  const isHaveAppCustomersPermission = subscription?.plans?.permissions.includes("APP_CUSTOMERS") || business?.subscriptions?.plans?.permissions.includes("APP_CUSTOMERS") || false;
  const isPointManagementPermission = subscription?.plans?.permissions.includes("POINT_MANAGEMENT") || business?.subscriptions?.plans?.permissions.includes("POINT_MANAGEMENT") || false;

  const menus: menuItemsProps[] = [
    {
      name: "Dashboard",
      to: "/dashboard",
      icon: "i-Home1",
      iconComponent: <RiDashboardFill size={30} style={{ marginBottom: 10 }} />,
      package: "Dashboard",
      subMenus: [],
      permissions: ['DASHBOARD'],
      active: activeMenus && isHaveDashboardPermission
    },
    {
      name: "Dashboard",
      to: "/dashboard",
      icon: "i-Home1",
      iconComponent: <RiDashboardFill size={30} style={{ marginBottom: 10 }} />,
      package: "Dashboard",
      subMenus: [],
      permissions: ['ROOT'],
    },
    {
      name: "Empresas",
      to: "/business",
      icon: "i-Home1",
      iconComponent: <FaRegBuilding size={30} style={{ marginBottom: 10 }} />,
      package: "Business",
      subMenus: [],
      permissions: ['ROOT'],
    },
    {
      name: "Usuários Remarketing",
      to: "/users-remarketing",
      icon: "i-Home1",
      iconComponent: <RiUserStarLine size={30} style={{ marginBottom: 10 }} />,
      package: "Usuários Remarketing",
      subMenus: [],
      permissions: ['ROOT'],
    },
    {
      name: "Gestão de pontos",
      to: "/points",
      icon: "i-Home1",
      iconComponent: <RiCoupon2Fill size={30} style={{ marginBottom: 10 }} />,
      package: "Gestão de pontos",
      subMenus: [],
      permissions: ['DASHBOARD'],
      active: activeMenus && isPointManagementPermission
    },
    {
      name: "Acomodações",
      to: "/accommodations",
      icon: "i-Management",
      iconComponent: <MdHotel size={30} style={{ marginBottom: 10 }} />,
      package: "Acomodações",
      //  permissions: ["ACCOMMODATIONS-LIST", 'ROOT'],
      active: activeMenus,
      subMenus: [
        {
          name: "Acomodações",
          to: "/",
          icon: "i-Management",
          iconComponent: <MdHotel size={25} style={{ marginBottom: 10 }} />,
          package: "Acomodações",
          permissions: ["ACCOMMODATIONS-LIST", 'ROOT'],
          active: activeMenus,
          subMenus: [],
        },
        {
          name: "Grupos de Acomodações",
          to: "/accommodations-types",
          iconComponent: <BsFillHouseFill size={19} />,
          icon: "i-Management",
          package: "Acomodações",
          subMenus: [],
          permissions: ['ACCOMMODATIONS-GROUPS-LIST']
        },
        {
          name: "Fechaduras Magikey",
          to: "/magikey-smartlocks",
          icon: "i-Management",
          iconComponent: (props: any) => (
            <Magikey
              {...props}
              isHovered={isHoveredMagikeyIcon}
              style={{ marginBottom: 10 }}
              size={30}
              color={theme === 'light' ? '#3A3A3A' : '#8A8A8A'}
              secondaryColor={secondary.dark}
            />
          ),
          package: "Fechaduras",
          subMenus: [],
          permissions: ["SMARTLOCKS-LIST"],
          active: activeMenus && isHaveMagikeyPermission
        },
      ]
    },
    {
      name: "Reservas",
      to: "/reservations",
      icon: "i-Management",
      iconComponent: <FaBook size={30} style={{ marginBottom: 10 }} />,
      package: "Reservas",
      subMenus: [],
      active: activeMenus,
      permissions: ["STAYS-RESERVATIONS-LIST", 'ROOT'],
    },
    {
      name: "Mensageria",
      to: "/messaging",
      icon: "i-Management",
      iconComponent: <MdMail size={30} style={{ marginBottom: 10 }} />,
      package: "Mensageria",
      active: activeMenus,
      subMenus: [
        {
          name: "Modelos de mensagens",
          to: "/message-models",
          icon: "i-Management",
          iconComponent: <MdOutlineDocumentScanner size={19} />,
          package: "Configurações",
          subMenus: [],
          permissions: ['MESSAGE-MODELS-LIST'],
          active: isHaveMsgTemplatesPermission ?? false,
        },
        {
          name: "Regras de notificação",
          to: "/notification-rules",
          iconComponent: <MdNotificationsActive size={19} />,
          icon: "i-Management",
          package: "Configurações",
          subMenus: [],
          permissions: ['NOTIFICATIONS'],
          active: isHaveMsgRulesPermission ?? false,
        },
        {
          name: "Histórico de Notificações",
          to: "/notifications-history",
          iconComponent: <FaHistory size={19} />,
          icon: "i-Management",
          package: "Configurações",
          subMenus: [],
          permissions: ['NOTIFICATIONS']
        },
      ]
    },
    {
      name: "Clientes App",
      to: "/clients-app",
      icon: "i-Management",
      iconComponent: <BsFilePersonFill size={30} style={{ marginBottom: 10 }} />,
      package: "Clientes App",
      subMenus: [],
      permissions: ["CUSTOMER-LIST"],
      active: activeMenus && isHaveAppCustomersPermission
    },
    {
      name: "Usuários",
      to: "/users",
      icon: "i-Management",
      iconComponent: <FaUserTie size={30} style={{ marginBottom: 10 }} />,
      package: "Usuários",
      permissions: ["USERS-LIST"],
      active: activeMenus,
      subMenus: [
        {
          name: "Usuários",
          to: "/",
          icon: "i-Management",
          iconComponent: <FaUserTie size={19} style={{ marginBottom: 10 }} />,
          package: "Usuários",
          subMenus: [],
          permissions: ["USERS-LIST"],
        },
        {
          name: "Tipos de Usuários",
          to: "/users-types",
          icon: "i-Management",
          package: "Configurações",
          iconComponent: <FaUserTag size={23} />,
          subMenus: [],
          permissions: ["USER-TYPES-LIST"],
        },
      ],
    },
    {
      name: "Integrações",
      to: "/integrations",
      icon: "i-Management",
      package: "Integrações",
      iconComponent: <AiFillApi size={30} style={{ marginBottom: 10 }} />,
      subMenus: [],
      permissions: ['INTEGRATIONS'],
      active: activeMenus || !user?.integration_stays_active
    },
    {
      name: "Assinatura",
      to: "/subscription",
      icon: "i-Management",
      package: "Assinatura",
      iconComponent: <BsCreditCardFill size={30} style={{ marginBottom: 10 }} />,
      subMenus: [],
      permissions: ['SETTINGS-LIST', 'ROOT'],
      active: user.is_root ? true : user?.user_type?.name === 'ADMINISTRADOR'
    },
    {
      name: "Planos",
      to: "/plans",
      icon: "i-Home1",
      iconComponent: <TbReportMoney size={30} style={{ marginBottom: 10 }} />,
      package: "Business",
      subMenus: [],
      permissions: ['ROOT']
    },
    {
      name: "Aplicativo",
      to: "/mobile-app",
      icon: "i-Management",
      iconComponent: <MdAppSettingsAlt size={19} />,
      package: "Configurações",
      subMenus: [],
      permissions: ["SETTINGS-LIST"],
      active: isHaveAppModulePermission ?? false,
    },
    {
      name: "Configurações",
      to: "/settings",
      icon: "i-Management",
      iconComponent: <IoSettingsOutline size={30} style={{ marginBottom: 10 }} />,
      package: "Configurações",
      active: activeMenus,
      subMenus: [],
      permissions: ["SETTINGS-LIST"],
    },
    {
      name: "Configurações",
      to: "/settings",
      icon: "i-Management",
      iconComponent: <IoSettingsOutline size={30} style={{ marginBottom: 10 }} />,
      package: "Configurações Root",
      active: activeMenus,
      permissions: ['ROOT'],
      subMenus: [
        {
          name: "Geral",
          to: "/general-default",
          icon: "i-Gears",
          package: "Configurações",
          subMenus: [],
          permissions: ["ROOT"],
        },
        {
          name: "Regras de notificação padrão",
          to: "/notification-rules-default",
          iconComponent: <MdNotificationsActive size={19} />,
          icon: "i-Management",
          package: "Configurações",
          subMenus: [],
          permissions: ['ROOT'],
        },
        {
          name: "Modelos de mensagens padrão",
          to: "/message-models-default",
          icon: "i-Management",
          iconComponent: <MdOutlineDocumentScanner size={19} />,
          package: "Configurações",
          subMenus: [],
          permissions: ['ROOT'],
        },
      ].filter(({ to }) => (to !== '/notification-rules' && to !== '/notifications-history') || AppConstants.PLAN === 'PRO') as any[],
    },
  ];

  const clickLink = useCallback(
    (event, menuItem: menuItemsProps) => {
      if (isMobile && menuItem.subMenus.length > 0) {
        if (subMenuOpen) {
          if (
            menuItemSelected.name === menuItem.name &&
            menuItemSelected.package === menuItem.package
          )
            setSubMenuOpen(false);
          else {
            setMenuItemSelected(menuItem);
            setSubMenuOpen(true);
          }
        } else {
          setMenuItemSelected(menuItem);
          setSubMenuOpen(true);
        }
        event.preventDefault();
      } else {
        if (
          menuItemSelected.name === menuItem.name &&
          menuItemSelected.package === menuItem.package
        ) {
          setSubMenuOpen(!subMenuOpen);
        }
      }
    },
    [menuItemSelected, subMenuOpen, isMobile]
  );

  const clickSubLink = useCallback((event, menuItem: menuItemsProps) => {
    if (menuItem.subMenus.length > 0) {
      setSubMenuItemSelected((atual) => {
        return atual.name === menuItem.name &&
          atual.package === menuItem.package
          ? ({} as menuItemsProps)
          : menuItem;
      });
      event.preventDefault();
    } else setSubMenuOpen(false);
  }, []);

  const hoverLink = useCallback(
    (menuItem: menuItemsProps) => {
      if (!isMobile) {
        if (menuItem.subMenus.length > 0) {
          setMenuItemSelected(menuItem);
          setSubMenuOpen(true);
        } else setSubMenuOpen(false);
      }
    },
    [isMobile]
  );

  const clickActiveIndicator = useCallback((menuItemId) => {
    document.getElementById(menuItemId)?.click();
  }, []);

  const getHeight = useCallback(() => {
    const header = document.getElementById("header-content");
    return `calc(calc(100 * var(--vh)) - ${header?.clientHeight}px)`;
  }, []);

  useEffect(() => {
    setSubMenuItemSelected({} as menuItemsProps);
  }, [menuItemSelected]);

  return (
    <Container theme={theme} menuOpen={menuOpen}>
      <div
        id="nav-sidebar"
        style={{ display: "flex", flexDirection: "row", height: "100%" }}
      >
        <MenuList theme={theme}>
          <PerfectScrollbar
            style={{ maxHeight: getHeight() }}
            options={{ suppressScrollY: false, suppressScrollX: true, }}
          >
            <>
              {menus.filter(({ active = true }) => active).filter(({ permissions = [], subMenus = [] }) => {
                const hasMenuPermission = permissions.some((p) => user.user_type.permissions.includes(p));

                const hasSubMenuPermission = subMenus.some(({ permissions = [] }) =>
                  permissions.length === 0 || permissions.some((p) => user.user_type.permissions.includes(p))
                );
                return hasMenuPermission || hasSubMenuPermission;
              })
                .filter(({ name }) => ['Gestão de pontos', 'Clientes App'].includes(name) ? AppConstants.HAS_APP : true)
                .map((item, index) => (
                  <Item
                    theme={theme}
                    onMouseEnter={() => hoverLink(item)}
                    noBorder={index === menus.length - 1}
                    key={`${item.name}-${item.icon}`}
                  >
                    <Link
                      style={{ maxHeight: 109.5, justifyContent: "center" }}
                      id={`link-to-${item.name}`}
                      theme={theme}
                      active={
                        item.package === menuItemSelected.package && subMenuOpen
                          ? true
                          : false
                      }
                      to={item.to}
                      onClick={(event: any) => clickLink(event, item)}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        {item.iconComponent && (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              minWidth: 30,
                            }}
                          >
                            {item.iconComponent}
                          </div>
                        )}
                        {!item.iconComponent && (
                          <IconLink className={item.icon} />
                        )}
                      </div>
                      <LinkName>{item.name}</LinkName>
                    </Link>
                    <ActiveIndicator
                      active={
                        item.package === menuItemSelected.package && subMenuOpen
                      }
                      onClick={() => clickActiveIndicator(`link-to-${item.name}`)}
                      theme={theme}
                    />
                  </Item>
                ))}
            </>
          </PerfectScrollbar>
        </MenuList>
        <SubMenuList
          open={
            subMenuOpen &&
            menuItemSelected.subMenus &&
            menuItemSelected.subMenus.length > 0
          }
          theme={theme}
        >
          <PerfectScrollbar
            style={{
              maxHeight: "calc(calc(100 * var(--vh)) - 82px)",
              paddingTop: 10,
              paddingBottom: 10,
            }}
            options={{ suppressScrollY: false }}
          >
            <>
              {menuItemSelected.subMenus &&
                menuItemSelected.subMenus.filter(
                  ({ permissions = [] }) =>
                    !!permissions.some((p) =>
                      user.user_type.permissions.includes(p)
                    )
                )
                  .filter(({ permissions = [] }) => {
                    if (user?.is_root) {
                      return permissions.includes('ROOT');
                    }
                    return true;
                  })
                  .filter(({ active = true }) => active)
                  .map((subMenu) => (
                    <React.Fragment key={subMenu.name + '-' + subMenu.to + '-' + subMenu.package}>
                      <ItemSubMenu
                        active={
                          subMenuItemSelected.name === subMenu.name &&
                          subMenu.package === subMenuItemSelected.package
                        }
                        key={subMenu.name + '-' + subMenu.to + '-' + subMenu.package}
                      >
                        <Link
                          id={`link-to-${subMenu.name}`}
                          active={false}
                          theme={theme}
                          to={`${menuItemSelected.to}${subMenu.to}`}
                          onMouseEnter={() => subMenu.name === "Fechaduras Magikey" ? setIsHoveredMagikeyIcon(true) : {}}
                          onMouseLeave={() => {
                            if (menuItemSelected.name !== "Fechaduras Magikey") {
                              setIsHoveredMagikeyIcon(false);
                            }
                          }}
                          style={{
                            padding: 10,
                            paddingLeft: 20,
                            paddingRight: 20,
                            flexDirection: "row",
                          }}
                          onClick={(event: any) => clickSubLink(event, subMenu)}
                        >
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                minWidth: 29,
                                marginRight: 10
                              }}
                            >
                              {subMenu.iconComponent && (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "start",
                                    alignItems: "start",
                                    maxWidth: 30,
                                  }}
                                >
                                  {subMenu.name === "Fechaduras Magikey" ? (
                                    <Magikey
                                      isHovered={isHoveredMagikeyIcon}
                                      style={{ marginBottom: 10 }}
                                      size={30}
                                      color={theme === 'light' ? '#3A3A3A' : '#8A8A8A'}
                                      secondaryColor={secondary.dark}
                                    />
                                  ) : (
                                    subMenu.iconComponent
                                  )}
                                </div>)}
                              {!subMenu.iconComponent && (
                                <IconSubMenu className={subMenu.icon} />
                              )}

                            </div>

                            <span style={{ textAlign: "left" }}>
                              {subMenu.name}
                            </span>

                          </div>
                          {subMenu.subMenus.length > 0 && (
                            <IconArrow
                              open={
                                subMenuItemSelected.name === subMenu.name &&
                                subMenu.package === subMenuItemSelected.package
                              }
                              theme={theme}
                              className="i-Arrow-Down"
                              data-fullscreen
                            />
                          )}
                        </Link>
                      </ItemSubMenu>
                      <ContainerSubSubMenuItems
                        maxHeight={subMenu.subMenus.length * 60}
                        open={
                          subMenuItemSelected.name === subMenu.name &&
                          subMenu.package === subMenuItemSelected.package
                        }
                        key={subMenu.name + '-' + subMenu.to + '-' + subMenu.package + '-container'}
                      >
                        {subMenu.subMenus.map((subSubMenu) => (
                          <ItemSubMenu key={subSubMenu.name + '-' + subSubMenu.to + '-' + subMenu.name}>
                            <Link
                              active={false}
                              theme={theme}
                              to={`${menuItemSelected.to}${subMenuItemSelected.to}${subSubMenu.to}`}
                              style={{
                                padding: 10,
                                paddingLeft: 49,
                                paddingRight: 20,
                                flexDirection: "row",
                              }}
                            >
                              <span style={{ textAlign: "left" }}>
                                {subSubMenu.name}
                              </span>
                            </Link>
                          </ItemSubMenu>
                        ))}
                      </ContainerSubSubMenuItems>
                    </React.Fragment>
                  ))}
            </>
          </PerfectScrollbar>
        </SubMenuList>
      </div>
    </Container>
  );
};
